import { initSlider } from '../../slider/scripts/initSlider';

const swiperContainerClass = '.gallery-box';
const galleryBoxToggle = document.querySelectorAll('.gallery-box__toggle');
const galleryBoxLength = document.querySelectorAll(swiperContainerClass).length;
let width = window.innerWidth;

let swipers = [];

function choiceInitSlider() {
  setTimeout(() => {
    if (galleryBoxLength > 1) {
      swipers = initSlider(swiperContainerClass);
    } else {
      swipers.push(initSlider(swiperContainerClass));
    }
  }, 300);
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/gallery-box', () => {
      initSlider(swiperContainerClass);
    });
  } else {
    choiceInitSlider();
  }
});

galleryBoxToggle.forEach((item, key) => {
  item.addEventListener('click', () => {
    const galleryBox = item.closest('.gallery-box');
    const galleryBoxSlider = galleryBox.querySelector('.gallery-box__slider');
    const galleryBoxNavigationPosition = galleryBox.querySelector('.gallery-box__navigation-position');
    galleryBoxSlider.classList.toggle('gallery-box__grid');
    galleryBoxSlider.classList.toggle('swiper-wrapper');
    galleryBoxNavigationPosition.classList.toggle('d-none');
    galleryBox.querySelectorAll('.gallery-box-caption').forEach((caption) => {
      caption.classList.toggle('d-none');
    });

    item.closest('.gallery-box__toggle-position').classList.toggle('active');
    setTimeout(() => {
      item.focus();
      item.scrollIntoView(false);
    }, 500);

    if (!swipers[key].enabled) {
      setTimeout(() => {
        galleryBoxNavigationPosition.after(galleryBox.querySelector('.gallery-box__toggle-position'));
        if (window.innerWidth > 768) {
          galleryBox.querySelector('.gallery-box__button--next').click();
        } else {
          swipers[key].slideTo(1, 100, true);
        }
      }, 500);
      swipers[key].enable();
    } else {
      swipers[key].disable();
      const galleryBoxSlidePosition = galleryBox.querySelector('.slide__4:not(.swiper-slide-duplicate)');

      if (galleryBoxSlidePosition) {
        setTimeout(() => {
          galleryBoxSlidePosition.before(galleryBox.querySelector('.gallery-box__toggle-position'));
        }, 300);
      }
    }
    setTimeout(() => {
      galleryBoxSlider.classList.toggle('gallery-box__row');
    }, 300);
  });
});

window.addEventListener('resize', () => {
  if (window.innerWidth !== width) {
    width = window.innerWidth;

    document.querySelectorAll('.gallery-box__toggle-position.active').forEach((item) => {
      item.querySelector('.gallery-box__toggle').click();
    });

    swipers.forEach((swiper) => {
      swiper.destroy(true, true);
    });

    swipers = [];

    choiceInitSlider();
  }
});
